import { Timeline, timelineItemClasses } from "@mui/lab";
import { Stack, Typography } from "@mui/material";
import type { MemberChangeContributor } from "../../../../../api/types/workflowTypes";
import ContributionTimelineItem from "./ContributionTimelineItem";

interface Props {
  workflowId: string;
  contributors: MemberChangeContributor[];
}

const MembersChangeRequestContributionHistory = ({ workflowId, contributors }: Props) => {
  if (contributors.length === 0) {
    return null;
  }

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Typography variant="subtitle1">Contributors</Typography>
      <Timeline sx={{ p: 0, m: 0, [`&& .${timelineItemClasses.root}::before`]: { flex: 0, p: 0 } }}>
        {contributors.map((contributor, index) => (
          <ContributionTimelineItem
            key={contributor.contributorUserId}
            workflowId={workflowId}
            contributor={contributor}
            isLast={index === contributors.length - 1}
          />
        ))}
      </Timeline>
    </Stack>
  );
};

export default MembersChangeRequestContributionHistory;
